import React from 'react';
import { Card, CardContent } from '@material-ui/core';
import styles from './styles.module.scss';
import ctx from 'classnames';

const LoadingCard: React.FunctionComponent = (): JSX.Element => {
  return (
    <Card elevation={1} square>
      <CardContent className={styles.dummyCard}>
        <div className={styles.header}>
          <div className={styles.picture}></div>
          <div className={ctx(styles.text, styles.lines)}>
            <div className={ctx(styles.line, styles.threeQuarter)}></div>
            <div className={ctx(styles.line, styles.half)}></div>
          </div>
        </div>
        <div className={styles.body}>
          <div className={ctx(styles.text, styles.lines)}>
            <div className={ctx(styles.line, styles.ninety)}></div>
            <div className={ctx(styles.line, styles.threeQuarter)}></div>
            <div className={ctx(styles.line, styles.eightyFive)}></div>
            <div className={ctx(styles.line, styles.eighty)}></div>
            <div className={ctx(styles.line, styles.quarter)}></div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default React.memo(LoadingCard);
